const {
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_BASE_URL: BASE_URL,
  VITE_API_URL: API_URL,
  VITE_CUSTOMER_UI_URL: CUSTOMER_UI_URL,
  VITE_MAX_RETRY: MAX_RETRY,
  VITE_CLOUDINARY_NAME: CLOUDINARY_NAME,
  VITE_CLOUDINARY_UPLOAD_PRESET: CLOUDINARY_UPLOAD_PRESET,
  VITE_APP_GOOGLE_API_KEY: GOOGLE_API_KEY,
  VITE_BOOST_REWARDS_MIN_LENGTH: BOOST_REWARDS_MIN_LENGTH,
  VITE_BOOST_REWARDS_MAX_LENGTH: BOOST_REWARDS_MAX_LENGTH,
  VITE_BOOST_TERMS_AND_CONDITIONS_URL: BOOST_TERMS_AND_CONDITIONS_URL,
  VITE_CLOUDFLARE_SITE_KEY: CLOUDFLARE_SITE_KEY,
  VITE_HELP_CENTER_URL: HELP_CENTER_URL,
} = import.meta.env;

export {
  ENVIRONMENT,
  BASE_URL,
  API_URL,
  CUSTOMER_UI_URL,
  MAX_RETRY,
  CLOUDINARY_NAME,
  CLOUDINARY_UPLOAD_PRESET,
  GOOGLE_API_KEY,
  BOOST_REWARDS_MIN_LENGTH,
  BOOST_REWARDS_MAX_LENGTH,
  BOOST_TERMS_AND_CONDITIONS_URL,
  CLOUDFLARE_SITE_KEY,
  HELP_CENTER_URL,
};
